
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.425 9.124c.625.238 1.16.502 1.62.854.555.426.99.973 1.343 1.735.17.366-.027.77-.395.913-.36.139-.792-.009-.956-.363a4.616 4.616 0 00-.07-.145c-.387-.764-.926-1.286-1.6-1.623a4.666 4.666 0 00-1.304-.413 7.822 7.822 0 00-1.328-.104c-2.782 0-5.013 2.062-5.013 4.56 0 .398-.348.69-.736.69s-.736-.292-.736-.69c0-2.376 1.527-4.418 3.712-5.369-1.133-.76-1.879-1.993-1.879-3.388 0-2.332 2.071-4.197 4.578-4.197 2.506 0 4.577 1.865 4.577 4.197 0 1.368-.717 2.58-1.813 3.343zm-5.87-3.343c0-1.537 1.376-2.818 3.106-2.818 1.729 0 3.105 1.28 3.105 2.818 0 1.537-1.376 2.818-3.105 2.818-1.73 0-3.106-1.281-3.106-2.818zm10.292 9.25H8.861c-.389 0-.736-.292-.736-.69 0-.397.347-.69.736-.69h7.986c.389 0 .736.293.736.69 0 .398-.347.69-.736.69zm-7.986 2.627c-.389 0-.736-.291-.736-.69 0-.397.347-.689.736-.689h5.032c.388 0 .736.292.736.69 0 .398-.348.69-.736.69H8.861z","fill":"#1D3C6F"}})])
          )
        }
      }
    